export const INITIAL_CONFIG_KEY = "default";
export const DEFAULT_CONFIG_KEY = "defaultConfigKey";
export const SAVED_CONFIG_KEY   = "currentConfigName";
export const SAVED_CREDS_KEY    = "authHeaders";

export const APP_INITIALIZED = 'APP_INITIALIZED';
export const ORGANISATION_FETCHED = 'ORGANISATION_FETCHED';

export const QUOTE_CALCULATED = 'QUOTE_CALCULATED';

export const QUOTES_FETCH_REQUESTED = 'QUOTES_FETCH_REQUESTED';
export const QUOTES_FETCHED = 'QUOTES_FETCHED';
export const QUOTES_FETCH_FAILED = 'QUOTES_FETCH_FAILED';

export const ORG_LOANS_FETCH_REQUESTED = 'ORG_LOANS_FETCH_REQUESTED';
export const ORG_LOANS_FETCHED = 'ORG_LOANS_FETCHED';
export const ORG_LOANS_FETCH_FAILED = 'ORG_LOANS_FETCH_FAILED';

export const LOANS_FETCH_REQUESTED = 'LOANS_FETCH_REQUESTED';
export const LOANS_FETCHED = 'LOANS_FETCHED';
export const LOANS_FETCH_FAILED = 'LOANS_FETCH_FAILED';

export const APPLICATION_FETCHED = 'APPLICATION_FETCHED';
export const APPLICATIONS_FETCHED = 'APPLICATIONS_FETCHED';
export const APPLICATIONS_FILTERED = 'APPLICATIONS_FILTERED';

export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';
export const FETCH_BEGIN = 'FETCH_BEGIN';
export const FETCH_END = 'FETCH_END';

export const XERO_SNAPSHOT_FETCHED = 'XERO_SNAPSHOT_FETCHED';



// WEBPACK FOOTER //
// ./src/utils/constants.js